import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_back",
  "use": "icon-ic_back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_back\">\n<path d=\"M5.82843 11.0003L22 11.0003V13.0003L5.82843 13.0003L12.6066 19.7784L11.1924 21.1926L2.35356 12.3538C2.15829 12.1586 2.15829 11.842 2.35356 11.6467L11.1924 2.80786L12.6066 4.22207L5.82843 11.0003Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol